import { navs } from "../constant/header";

export const findParentRoute = (pathname = '') => {
  const top = pathname.split('/')[1];
  if(top && navs.find(({ key = '' }) => key === `/${top}`)){
    return [`/${top}`,pathname]
  }else{
    return pathname
  }
}